export const getTableReduxProps = (state, tableId) => {
    if(Array.isArray(tableId)) {
        for(const _tableId of tableId) {
            const tableProps = getTableReduxProps(state, _tableId);
            if(!!tableProps) {
                return tableProps;
            }
        }
        return null;
    }
    if(!tableId || !state.table.tables[tableId]) {
        return null;
    }
    return state.table.tables[tableId];

}
